import { Flex, Text } from '@raystack/apsara';

import { ReactComponent as CartIcon } from '@src/components/Sidebar/new_icons/cart.svg';
import { Show } from '@src/hoc';
import { useOrderItemInCartList } from '@src/hooks';

import styles from './CartSidebarIcon.module.css';

const ShowCartCount = () => {
  const { cartCount } = useOrderItemInCartList();
  return (
    <Show when={cartCount > 0}>
      <Flex className={styles.showCartCount} align='center' justify='center'>
        <Text className={styles.cartCount}>{cartCount}</Text>
      </Flex>
    </Show>
  );
};

export const CartSidebarIcon = () => {
  return (
    <div className={styles.container}>
      <CartIcon />
      <ShowCartCount />
    </div>
  );
};
